import Facebook from './Facebook'
import axios from 'axios'

export default class Adsets extends Facebook {
  constructor (user, parameters = null) {
    super(user)
    this.user = user
    this.parameters = parameters
  }
  fetchAdsets () {
    return axios({
      method: 'GET',
      url: `${this.user.selectedAdAccount}/adsets`,
      params: {
        access_token: this.user.token
      }
    })
      .then(res => {
        return res.data
      })
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  fetchAdsetInsignts () {
    // const Adset = this.SdkClass().AdSet
    // let adset = new Adset(this.parameters.adsetId)
    // const fields = [
    //   'impressions', 'spend', 'adset_id', 'adset_name', 'campaign_id', 'reach', 'cpm', 'cpc',
    //   'clicks', 'ctr'
    // ]
    // const params = {
    //   time_range: {
    //     since: this.parameters.startDate,
    //     until: this.parameters.endDate
    //   }
    // }
    // return new Promise(resolve => {
    //   resolve(adset.getInsights(fields, params))
    // })
    //   .then(res => {
    //     if (res[0]) {
    //       return res[0]._data
    //     } else return {}
    //   })
    //   .catch(err => {
    //     throw new Error(JSON.stringify(err))
    //   })
    return new Promise(resolve => {
      resolve(true)
    })
  }
  createAdset () {
    const account = this.connection().account
    let promotedObject
    if (this.parameters.pixelId) {
      promotedObject = {
        pixel_id: this.parameters.pixelId,
        custom_event_type: 'LEAD'
      }
    } else {
      promotedObject = {
        page_id: this.parameters.pageId
      }
    }
    const params = {
      status: 'PAUSED',
      targeting: this.parameters.targeting,
      name: this.parameters.adSetName,
      billing_event: 'IMPRESSIONS',
      promoted_object: promotedObject,
      instagram_actor_id: this.parameters.pageId,
      campaign_id: this.parameters.campaignId,
      optimization_goal: this.parameters.objective,
      start_time: this.parameters.start_time,
      end_time: this.parameters.end_time
    }
    params.targeting.publisher_platforms = ['facebook']
    return account.createAdSet([], params)
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
}
